module.exports = __webpack_public_path__ + "static/media/CorePartners_LogoRGB_positivo.070721c5.png";